import React from 'react';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import './Advantages.scss';
import AdvantagesSlider from './Slider';

interface IAdvantagesProps {
  freeTrialEligible: boolean;
  context?: IContent;
}

const Advantages = ({ context }: IAdvantagesProps) => {
  const showcaseTitles = context.benefits.slider.filter(slide => slide.visible === "yes").map(slide => slide.trackingCode);

  return (
    <section className="advantages-wrapper">
      <h1
        id={'advantages_header'}
        className={'advantages_header'}
        dangerouslySetInnerHTML={{ __html: context.benefits_title }}
      />
      <AdvantagesSlider
        slideTitles={showcaseTitles}
        slides={context.benefits.slider}
      />
    </section>
  );
};


export default withContent(Advantages);
